// src/oura/overview/HubNextCard.tsx
//
// The one Next card at the top of a business's Overview, for every stage
// (JOURNEY-SPEC v1.1 §2.2): label "Next", one tag, a title, one line, one
// button (and a quieter one when the Onboarding card has it), and the violet
// bar while a scan runs.
//
// Drawn by the same frame as the Onboarding page's Next card (NextCardFrame),
// and fed the same `nextAction()` words while a client is being set up, so
// both pages say the same thing.

import { PillButton } from "@oura/ui";
import type { HubAct, HubNext } from "./hubStage";
import { NextCardFrame } from "./NextCardFrame";

export function HubNextCard({
    next, onAct, busy = false, label = "First AI check",
}: { next: HubNext; onAct: (a: HubAct) => void; busy?: boolean; label?: string }) {
    const act = next.act;
    const secondary = next.secondary;
    return (
        <NextCardFrame
            complete={next.onboarding?.kind === "done"}
            tag={next.tag}
            title={next.title}
            recipients={next.recipients}
            why={next.why}
            percent={next.percent}
            progressLabel={label}
            action={next.cta && act ? (
                <div className="flex shrink-0 flex-wrap items-center gap-2 max-sm:w-full">
                    {secondary && (
                        <PillButton variant="text" onClick={() => onAct(secondary.act)} disabled={busy} className="max-sm:h-9">{secondary.label}</PillButton>
                    )}
                    <PillButton variant={next.primary ? "primary" : "secondary"} onClick={() => onAct(act)} busy={busy} className="max-sm:h-9">
                        {next.cta}
                    </PillButton>
                </div>
            ) : null}
        />
    );
}
